import React, { FC } from "react";
import { Routes, Route } from "react-router-dom";
import ReviewQueuePage from "./ReviewQueuePage";
import { Role } from "common/Constants";
import ProtectedRoute from "common/ProtectedRoute";

export const ReviewQueueRouter: FC<{}> = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <ProtectedRoute roles={[Role.Admin, Role.TripAdmin]}>
            <ReviewQueuePage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
};

export default ReviewQueueRouter;
